'use client'

import { Box, Typography, alpha } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";

type ErrorBannerProps = {
  error?: string | null;
};

export default function ErrorBanner({ error }: ErrorBannerProps) {
  return (
    <Box sx={{ position: "relative", minHeight: 0 ,marginTop: 0.5 }}>
      <AnimatePresence mode="wait">
        {error && (
          <Box
            component={motion.div}
            key="error-banner"
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            transition={{ duration: 0.22, ease: "easeOut" }}
            sx={{
              position: "absolute",
              inset: 0,
            }}
          >
            <Box
              sx={(theme) => ({
                backgroundColor: alpha(theme.palette.error.main, 0.12),
                color: theme.palette.error.main,
                borderRadius: 4,
                px: 1,
                py: 0.5,
                fontSize: "0.75rem",
                lineHeight: 1.35,
                display: "flex",
                alignItems: "center",
                justifyContent:'center'
              })}
            >
              <Typography variant="body2" textAlign={'center'}>
                {error}
              </Typography>
            </Box>
          </Box>
        )}
      </AnimatePresence>
    </Box>
  );
}
